import { DESKTOP_SPACING, SECONDARY_RED } from '@/theme';

import { StyledInputColorProps } from './InputColor.interface';
import styled from 'styled-components';

export const StyledInputColor = styled.input<StyledInputColorProps>`
  border-radius: 4px;
  display: block;
  height: 44px;
  line-height: 22px;
  margin: ${DESKTOP_SPACING.XXL}px 0;
  outline: none;
  padding: ${DESKTOP_SPACING.SM}px;
  width: ${({ fullWidth }) => fullWidth ? '150px' : 'auto'};

   ${({ state }) => state === 'error' ? `box-shadow: 0px 0px 0px 2px ${SECONDARY_RED.LIGHTER};` : ''}

  ::placeholder {
    opacity: 0;
  }

  :focus::placeholder {
    opacity: 1;
  }
`;